import { render, staticRenderFns } from "./AssistantDashboard.vue?vue&type=template&id=96f35bd6"
import script from "./AssistantDashboard.vue?vue&type=script&lang=js"
export * from "./AssistantDashboard.vue?vue&type=script&lang=js"
import style0 from "./AssistantDashboard.vue?vue&type=style&index=0&id=96f35bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports